<div class="lugas-general-container" *ngIf="!isVerificationSow; else verificationContainerShow">
  <div class="header-container">
    <div class="header-item">
      {{ 'Lugas_Text_1' | t }}
    </div>
  </div>
  <div class="up-info-container">
    <div class="up-info-item">
      {{ 'Lugas_Text_2' | t }}
    </div>
  </div>
  <div class="lugas-input-container">
    <div class="lugas-row" [ngClass]="{ disabled: warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3' }">
      <input
        type="radio"
        value="10000"
        id="10000"
        [(ngModel)]="inputTypeModel"
        [disabled]="warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3'" />

      <label for="10000">{{ 'Lugas_Text_3' | t }}</label>
    </div>
    <ng-container *ngIf="warningMessage === 'step_1'">
      <div class="lugas-row warning-msg">
        <label for="0">{{ 'Lugas_Text_7' | t }}</label>
      </div>
    </ng-container>

    <div class="lugas-row" [ngClass]="{ disabled: warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3' }">
      <input
        type="radio"
        value="1000"
        id="1000"
        [(ngModel)]="inputTypeModel"
        [disabled]="warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3'" />

      <label for="1000">{{ 'Lugas_Text_4' | t }}</label>
    </div>

    <ng-container *ngIf="warningMessage === 'step_2'">
      <div class="lugas-row warning-msg">
        <label for="0">{{ 'Lugas_Text_7' | t }}</label>
      </div>
    </ng-container>
    <div class="lugas-row" [ngClass]="{ disabled: warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3' }">
      <input
        type="radio"
        [value]="this.thirdInputValue"
        id="99999"
        [(ngModel)]="inputTypeModel"
        [disabled]="warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3'" />

      <label for="99999">{{ 'Lugas_Text_5' | t }}</label>
    </div>
    <!-- <ng-container *ngIf="warningMessage==='step_3'">
      <div class="lugas-row warning-msg lugas-warning">
        <label for="0">{{'Lugas_Text_8' | t}}</label>
      </div>
    </ng-container> -->
  </div>

  <ng-container *ngIf="warningMessage === 'step_1' || warningMessage === 'step_2' || warningMessage === 'step_3'; else firstButton">
    <div class="button-container" style="display: flex">
      <div (click)="change_Tab('cancel')" class="btn colored register-button save-changes-button confirm-button flexible error">
        <div class="btn-text" style="color: #fff !important">
          {{ 'b3000_cancel' | t }}
        </div>
      </div>
      <div (click)="saveLimitChange()" class="btn colored register-button save-changes-button confirm-button flexible green">
        <div class="btn-text" style="color: #fff !important">
          {{ 'Confirm' | t }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #firstButton>
    <div
      *ngIf="inputTypeModel !== '99999' && inputTypeModel !== '1000' && inputTypeModel !== '10000'; else abledButton"
      style="opacity: 0.5"
      class="btn colored register-button save-changes-button confirm-button green">
      <div class="btn-text" style="color: #fff !important">
        {{ 'Confirm' | t }}
      </div>
    </div>

    <ng-template #abledButton>
      <div (click)="change_Tab('firstStep')" class="btn colored register-button save-changes-button confirm-button green">
        <div class="btn-text" style="color: #fff !important">
          {{ 'Confirm' | t }}
        </div>
      </div>
    </ng-template>
    <div class="customer-info-container">
      <ng-container *ngIf="isOldCustomer; else OldCustomer">
        <div>{{ 'Lugas_Text_25' | t }}</div>
      </ng-container>
      <ng-template #OldCustomer>
        <div>{{ 'Lugas_Text_26' | t }}</div>
      </ng-template>
    </div>
  </ng-template>
</div>
<ng-template #verificationContainerShow>
  <div class="scufa-info-container">
    <div class="scufa-info-row">
      <div class="scufa-info-row-left" (click)="backButton()">
        <div class="left-svg">
          <image-loader-utils url="back" extraClasses=" "></image-loader-utils>
        </div>
      </div>
      <div class="scufa-info-row-right">
        <span>
          {{ 'Lugas_Text_11' | t }}
          <a class="contact-support" target="_blank" [href]="'contactUrl' | getEnv">
            {{ 'Lugas_Text_12' | t }}
          </a>
          {{ 'Lugas_Text_13' | t }}
        </span>
      </div>
    </div>
  </div>
  <verification-sow-component [showInfoContainer]="false"></verification-sow-component>

  <!-- <div class="widget-general-container">
    <div class="widget-header-container" >
      <span style="margin-right: 7px;" class="navbarIcon" (click)="backButton()"><fa-icon [icon]="faIcons.faArrowLeft"></fa-icon> </span>
      <div>
        {{'Back'| t}}
      </div>


    </div>

  </div> -->
</ng-template>
